import {Plan} from "../../../types";
import {ValidationMessage, MessageOpts} from "../../types";
import {validateManholeOpeningDirections} from "../rules/manholeOpeningDirectionValidation";

export const getManholeOpeningDirectionErrorMessages = (plan: Plan, opts: MessageOpts): ValidationMessage[] => {
    const {
        resolveLocation,
        resolveLocationText,
        severity = 'error',
    } = opts;
    const validationResult = validateManholeOpeningDirections(plan);

    return validationResult.issues.map(i => {
        return {
            message: "Entgegengesetzte Öffnungsrichtungen sind nicht erlaubt",
            severity: severity,
            ...(resolveLocation ? {resolveLocation} : {}),
            ...(resolveLocationText ? {resolveLocationText} : {}),
            ...(i.ids.length > 0 ? {ids: i.ids} : {}),
        }
    })
}

export const getManholeOpeningDirectionErrorIds = (plan: Plan): string[] => {
    const validationResult = validateManholeOpeningDirections(plan);

    return validationResult.issues.map(i => {
        return i.ids
    }).flat()
}
